<script lang="ts" module>
  import type { AnyConfigurationSection } from '@/teoCore/config/config-setup.types';
  import { isTeoError, TeoError } from '@/teoCore/errors/TeoError';
  import LinkButton from '@/ui/elements/buttons/LinkButton.svelte';

  import ConfigCard from './cmps/ConfigCard.svelte';
  import ConfigMenuBtn from './cmps/ConfigMenuBtn.svelte';
  import { createConfigPanel } from './ConfigPanel.builder.svelte';
  import type { ConfigPanelProps } from './ConfigPanel.utils';
</script>

<script lang="ts" generics="TSection extends AnyConfigurationSection">
  import { useShowPDFPreview } from '@/utils/teo-context/flags';

  import ReportPdfPreview from '../report/ReportPdfPreview.svelte';

  let props: ConfigPanelProps<TSection> = $props();

  let { setup } = props;
  const C = createConfigPanel(props);
  const [showPDFPreview] = useShowPDFPreview();
</script>

<div
  class="fc-xc gap-4 rounded-md bg-plain p-4 shadow-card transition-all"
  use:C.closeOnClickOutside
>
  {#if showPDFPreview.current}
    <ReportPdfPreview />
  {/if}
  <div class=" fr-csb f-1 gap-4">
    <dl class="fr-cc gap-2 text-lsm font-normal">
      <dt>Konfiguration:</dt>
      {#if !setup}
        <dd>...</dd>
      {:else if TeoError.isError(setup)}
        <dd>Fehler: {setup.message}</dd>
      {:else}
        {#each setup.sections as section (section.id)}
          <dd>
            <LinkButton
              highlight={!!C.currentValues[section.id]}
              onclick={() => C.handleSectionSelect(section.id)}
              active={C.currentSection === section.id}>{C.getTabTitle(section)}</LinkButton
            >
          </dd>
          {#if !C.isLastSection(section)}
            <span role="separator">•</span>
          {/if}
        {/each}
      {/if}
    </dl>

    <ConfigMenuBtn
      onChange={(active) => C.handleSectionSelect(active ? 'all' : C.currentSection)}
      active={!!C.currentSection}
    />
  </div>
  {#if C.currentSection && setup && !isTeoError(setup)}
    <div class="fc gap-3 border-t border-c-divider pt-3 transition-all">
      {#each setup.sections as section (section.id)}
        {#if C.currentSection === section.id || C.currentSection === 'all'}
          <ConfigCard
            groupName={section.id}
            title={section.title}
            description={section.description}
            options={section.options}
            value={C.currentValues[section.id]}
            onchange={(value) => C.handleValueChange(section.id, value)}
          />
        {/if}
      {/each}
    </div>
  {/if}
</div>
